var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { equals } from "ramda";
import { StyledWrapper } from "components/mobile_pay/views/page";
import { getCheckTotal } from "helpers/mobile_pay";
var StyledCheckInfoWrapper = styled(StyledWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 20px;\n\n  text-align: left;\n\n  font-size: 20px;\n  line-height: 22px;\n"], ["\n  margin-bottom: 20px;\n\n  text-align: left;\n\n  font-size: 20px;\n  line-height: 22px;\n"])));
var StyledCheckInfoLineItem = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  gap: 5px;\n\n  padding: 5px 0;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  gap: 5px;\n\n  padding: 5px 0;\n"])));
var StyledCheckInfoTotalItem = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  gap: 5px;\n\n  padding: 5px 0;\n\n  border-top: 1px solid #ededed;\n  font-weight: bold;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  gap: 5px;\n\n  padding: 5px 0;\n\n  border-top: 1px solid #ededed;\n  font-weight: bold;\n"])));
export default function CheckInfoComponent(_a) {
    var checkInfo = _a.checkInfo;
    var netTotal = checkInfo.netTotal, mandatoryTip = checkInfo.mandatoryTip, mandatoryTipAmount = checkInfo.mandatoryTipAmount, tax = checkInfo.tax, balanceDue = checkInfo.balanceDue;
    var totalPaymentDueForCheck = getCheckTotal(checkInfo);
    var mandatoryTipLineItem = mandatoryTip.match({
        // eslint-disable-next-line react/no-multi-comp
        Just: function (tip) {
            return (React.createElement(StyledCheckInfoLineItem, null,
                React.createElement("span", null, "Included Gratuity (" + tip + "%)"),
                React.createElement("span", null, mandatoryTipAmount.format())));
        },
        Nothing: function () { return null; },
    });
    return (React.createElement(StyledCheckInfoWrapper, null,
        React.createElement(StyledCheckInfoLineItem, null,
            React.createElement("span", null, "Net Total (including fees and comps)"),
            React.createElement("span", null, netTotal.format())),
        mandatoryTipLineItem,
        React.createElement(StyledCheckInfoLineItem, null,
            React.createElement("span", null, "Tax"),
            React.createElement("span", null, tax.format())),
        !equals(totalPaymentDueForCheck, balanceDue) && (React.createElement(React.Fragment, null,
            React.createElement(StyledCheckInfoTotalItem, null,
                React.createElement("span", null, "Check Total"),
                React.createElement("span", null, totalPaymentDueForCheck.format())),
            React.createElement(StyledCheckInfoLineItem, null,
                React.createElement("span", null, "Payments"),
                React.createElement("span", null, totalPaymentDueForCheck.subtract(balanceDue).format())))),
        React.createElement(StyledCheckInfoTotalItem, null,
            React.createElement("span", null, "Balance Due"),
            React.createElement("span", null, balanceDue.format()))));
}
var templateObject_1, templateObject_2, templateObject_3;
